// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.speakers-page {
    min-height: 100vh;
    padding: 120px 20px 40px;
    background: #f8f9fa;
}

.speakers-container {
    max-width: 900px;
    margin: 0 auto;
}

.speakers-title {
    text-align: center;
    font-size: 2.5rem;
    color: #1a1a2e;
    margin-bottom: 40px;
}

.session-section {
    margin-bottom: 40px;
}

.session-banner {
    background: #3d4f6f;
    color: #fff;
    text-align: center;
    font-size: 1.15rem;
    font-weight: 600;
    padding: 14px 30px;
    border-radius: 30px;
    margin-bottom: 30px;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
}

.session-speakers {
    display: flex;
    flex-direction: column;
    gap: 30px;
}

.speaker-card {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 24px;
    padding: 0 20px;
}

.speaker-image-wrapper {
    width: 150px;
    height: 150px;
    min-width: 150px;
    border-radius: 50%;
    overflow: hidden;
}

.speaker-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.speaker-info {
    text-align: left;
    flex: 1 1;
}

.speaker-name {
    font-size: 1.15rem;
    font-weight: 700;
    color: #1a1a2e;
    margin: 0 0 2px;
}

.speaker-title {
    font-size: 0.95rem;
    color: #555;
    margin: 0 0 8px;
    font-style: italic;
}

.speaker-bio {
    font-size: 0.85rem;
    color: #444;
    line-height: 1.6;
    margin: 0;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}

.speaker-bio.expanded {
    -webkit-line-clamp: unset;
    display: block;
}

.bio-toggle {
    background: none;
    border: none;
    color: #57068c;
    font-size: 0.8rem;
    cursor: pointer;
    padding: 4px 0 0;
    font-weight: 500;
}

.bio-toggle:hover {
    text-decoration: underline;
}

@media (max-width: 600px) {
    .speaker-card {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .speaker-info {
        text-align: center;
    }

    .session-banner {
        font-size: 1rem;
        padding: 12px 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SpeakersPage/SpeakersPage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;QACI,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;AACJ","sourcesContent":[".speakers-page {\n    min-height: 100vh;\n    padding: 120px 20px 40px;\n    background: #f8f9fa;\n}\n\n.speakers-container {\n    max-width: 900px;\n    margin: 0 auto;\n}\n\n.speakers-title {\n    text-align: center;\n    font-size: 2.5rem;\n    color: #1a1a2e;\n    margin-bottom: 40px;\n}\n\n.session-section {\n    margin-bottom: 40px;\n}\n\n.session-banner {\n    background: #3d4f6f;\n    color: #fff;\n    text-align: center;\n    font-size: 1.15rem;\n    font-weight: 600;\n    padding: 14px 30px;\n    border-radius: 30px;\n    margin-bottom: 30px;\n    max-width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.session-speakers {\n    display: flex;\n    flex-direction: column;\n    gap: 30px;\n}\n\n.speaker-card {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 24px;\n    padding: 0 20px;\n}\n\n.speaker-image-wrapper {\n    width: 150px;\n    height: 150px;\n    min-width: 150px;\n    border-radius: 50%;\n    overflow: hidden;\n}\n\n.speaker-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n}\n\n.speaker-info {\n    text-align: left;\n    flex: 1;\n}\n\n.speaker-name {\n    font-size: 1.15rem;\n    font-weight: 700;\n    color: #1a1a2e;\n    margin: 0 0 2px;\n}\n\n.speaker-title {\n    font-size: 0.95rem;\n    color: #555;\n    margin: 0 0 8px;\n    font-style: italic;\n}\n\n.speaker-bio {\n    font-size: 0.85rem;\n    color: #444;\n    line-height: 1.6;\n    margin: 0;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n}\n\n.speaker-bio.expanded {\n    -webkit-line-clamp: unset;\n    display: block;\n}\n\n.bio-toggle {\n    background: none;\n    border: none;\n    color: #57068c;\n    font-size: 0.8rem;\n    cursor: pointer;\n    padding: 4px 0 0;\n    font-weight: 500;\n}\n\n.bio-toggle:hover {\n    text-decoration: underline;\n}\n\n@media (max-width: 600px) {\n    .speaker-card {\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n    }\n\n    .speaker-info {\n        text-align: center;\n    }\n\n    .session-banner {\n        font-size: 1rem;\n        padding: 12px 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
